import { useQuery } from "@tanstack/react-query";
import { notificationsService } from "@/services/notifications.service";
import { useAuth } from "@/contexts/AuthContext";

export function useUnreadCount() {
  const { isAuthenticated } = useAuth();

  const { data } = useQuery({
    queryKey: ["notifications-inbox", "unread-count"],
    queryFn: () => notificationsService.getInbox(50),
    enabled: isAuthenticated,
    staleTime: 60_000,
  });

  return data?.items.filter(item => !item.read).length ?? 0;
}
